import React from 'react';
import StackManager from '../components/supplements/StackManager';
import StackConfirmCard from '../components/supplements/StackConfirmCard';
import SupplementQuiz from '../components/supplements/SupplementQuiz';

// Supplements (2026-10 restyle): what you take, and what moved after you
// started. The daily confirm first, then your stack, then medications, then
// the honest "not sure what to take?" picker. Anonymous visitors get the
// picker alone at /quiz.

const SupplementsPage = () => (
  <div className="mx-auto max-w-[1080px] px-4 sm:px-6 lg:px-10">
    <div className="mb-[22px] flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="text-[1.75rem] font-medium leading-[1.15] tracking-[-0.02em]">Supplements</h1>
        <p className="mt-1 max-w-[40em] text-fg-3">What you take, and what moved after you started.</p>
      </div>
      <a href="#add" className="text-sm font-medium text-fg-2 hover:text-fg">+ Add one</a>
    </div>

    <StackConfirmCard framed />

    <StackManager />
    <SupplementQuiz showSignupCta={false} />
  </div>
);

export default SupplementsPage;
